import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    max-height: 450px;
    border-radius: 8px;
    justify-content: space-between;
    position: relative;
    margin-bottom: 2.5rem;
    overflow: hidden;
    border: 1px solid #e2e8f0;

    @media (max-width: 768px) {
        flex-direction: column;
        max-height: none;
        border-radius: 8px;
    }
`

export const ImageContainer = styled.div`
    flex: 1;
    height: 100%;
    cursor: pointer;

    @media (max-width: 768px) {
        width: 100%;
        height: 200px; /* fixed height for mobile */
    }
`

export const ImageComponent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px 0 0 8px;

    @media (max-width: 768px) {
        border-radius: 8px 8px 0 0;
        height: 100%;
    }
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 2rem;
    border-radius: 0 8px 8px 0;

    @media (max-width: 768px) {
        flex: unset; /* disable flex-grow on mobile */
        height: auto; /* shrink to content */
        padding: 1rem 1.5rem;
        border-radius: 0 0 8px 8px;
    }
`

export const DetailsContainer = styled.div`
    flex: 2;
    padding: 10px 20px;
    padding-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    height: 100%;

    @media (max-width: 768px) {
        height: auto; /* shrink to content on mobile */
        padding: 0;
    }
`

export const Title = styled.h2<{ fontSize: number }>`
    margin: 0;
    font-size: ${(props) => props.fontSize}px;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 30ch;

    @media (max-width: 768px) {
        white-space: normal;
        max-width: 100%;
        font-size: ${(props) => Math.min(props.fontSize, 32)}px;
        margin-bottom: 0;
    }
`

export const Description = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-style: italic;
    color: #685612;
    font-family: 'Poppins', sans-serif;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-width: 70ch;

    @media (max-width: 768px) {
        max-width: 100%;
        margin-top: 1.5rem;
    }
`

export const LocationBox = styled.div`
    max-width: 30rem;
    min-width: 0;
    height: fit-content;
    width: max-content;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
        white-space: normal;
        font-size: 12px;
        padding: 6px 16px;
    }
`

export const DateDisplay = styled.div`
    margin-bottom: 1rem;
    font-size: 16px;
    color: #000;
    font-weight: 500;

    @media (max-width: 768px) {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 0rem;
        margin-top: 0.5rem;
    }
`

export const WrapperRow = styled.div`
    display: flex;
    justify-content: center;
    margin: auto;
    margin-top: 1rem;
    margin-bottom: 1rem;
`
